<!-- Offcanvas menu toggle link (hidden when menu is open) -->
<div class="header-left-menu offcanvas-toggle-left" *ngIf="!isMenuOpen" (click)="toggleMenu()">
</div>

<!-- Backdrop (only shown when menu is open) -->
<div *ngIf="isMenuOpen" class="menu-backdrop" (click)="toggleMenu()"></div>

<!-- The menu container that toggles visibility based on 'isMenuOpen' -->
<nav [ngClass]="{
    'offcanvas': true,
    'sidenav': true,
    'animate__animated': true,
    'animate__fadeInLeft': isMenuOpen,
    'menu-open': isMenuOpen
  }" id="menu" aria-hidden="true">

  <!-- Conditionally render the menu template only when the menu is open -->
  <ng-container *ngIf="isMenuOpen">
    <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
  </ng-container>
</nav>

<!-- Template for the menu -->
<ng-template #menuTemplate>
  <div class="mm-panels">
    <div id="mm-1" class="mm-panel mm-panel_opened">
      <div class="mm-navbar mm-navbar_sticky">
        <a class="mm-navbar__title" (click)="toggleMenu()">
          <span>
            <img src="../../../assets/images/dap_mobile_menu_toggle.webp" alt="Menu" />
          </span>
          <div class="mobile-fix-menu">
            <div class="btn-close1" (click)="toggleMenu()">
              <span>
                <img src="../../../assets/images/prwpower_sidemenu_close.webp" alt="Close Menu" />
              </span>
            </div>
          </div>
        </a>
      </div>

      <!-- Menu items -->
      <ul class="nav navbar-nav header_mobile_menu mm-listview">
        <li class="shop_by_cat">Shop By Category</li>
        <li *ngFor="let category of menuData" class="mega-menu narrow mm-listitem">
          <a (click)="categoriesRedirection(category)"
            class="text_box custom-class_136 for_t_c btn btn-sm mm-listitem__text">
            {{ category.menu_name }}
          </a>
        </li>
      </ul>

      <!-- Cart and user info -->
      <ul class="nav navbar-nav header_mobile_menu cart_ico mm-listitem">
        <li>
          <a [routerLink]="['/cart']" (click)="toggleMenu()">
            <span class="img_wra">
              <img src="https://www.prwpower.com/assets/images/disc_mobile_cart_black.webp" alt="Cart" />
            </span>
            <span>Cart - $0.00</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/customer-login']" (click)="toggleMenu()">
            <span class="img_wra">
              <img src="https://www.prwpower.com/assets/images/disc_mobile_user_black.webp" alt="User" />
            </span>
            <span>My Account</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/customer-service']" (click)="toggleMenu()">
            <span class="img_wra">
              <img src="https://www.prwpower.com/assets/images/disc_mobile_support_black.webp" alt="Support" />
            </span>
            <span>Customer Support</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>